import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ExpandableComponent } from '../../common/expandable/expandable.component';

export namespace NCmsAccordion {
    export const componentId = 'accordion';
    export interface IItem {
        title: string;
        components?: NICmsContentComponent.IData[];
    }

    export interface IComponentData extends NICmsContentComponent.IData {
        items: IItem[];
    }
}

let uid = 0;

@ICmsComponent<CmsAccordionComponent>({
    id: NCmsAccordion.componentId,
    name: 'Accordion',
    tags: ['text', 'textarea'],
    isAdvanced: true,
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Item',
            itemName: 'Item',
            itemNameField: 'title',
            defaultSize: 1,
            required: true,
            fields: [
                {
                    key: 'title',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Title',
                    default: 'Title',
                    required: true
                },
                <NICmsContentField.IComponentsField>{
                    key: 'components',
                    type: NICmsContentField.EFieldType.components,
                    title: 'Content components',
                    itemName: 'component',
                    default: []
                }
            ],
            default: [
                { title: 'Accordion title', components: [] },
                { title: 'Second title', components: [] }
            ]
        }
    ]
})
@Component({
    selector: 'cms-accordion',
    templateUrl: './cms-accordion.html',
    imports: [ExpandableComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsAccordionComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsAccordion.IComponentData;

    readonly toggleGroupId = `cmsAccordion${uid++}`;
}
